export default "__VITE_ASSET__HK2YSRXT__"